<template>
    <div id="new_material">
        <CRUDTemplate
            :columns="columns"
            :create_index_item_url="create_index_item_url"
            :authentication_token="authentication_token"
            :index_item_name="index_item_name"
            :api_response_corresponding_name_of_index_item="api_response_corresponding_name_of_index_item"
            :after_create_url="after_create_url"
        >
    </CRUDTemplate>
    </div>
</template>

<script>
import CRUDTemplate from "@toolbox/crud_templates/new.vue"
export default {
    name: "NewMaterial",
    props: {
    },
    data() {
        return {
            columns: [
                {
                    // human_name: "物料名稱",
                    human_name: this.$t('models.attributes.materials.name'),
                    attribute_name: "name",
                    placeholder: this.$t('models.attributes.materials.name'),
                    type: "text",
                },
                {
                    // human_name: "物料英文",
                    human_name:  this.$t('models.attributes.materials.en_name'),
                    attribute_name: "en_name",
                    placeholder: this.$t('models.attributes.materials.en_name'),
                    type: "text",
                },
                {
                    // human_name: "運單階層",
                    human_name:  this.$t('models.attributes.materials.core_waybill_level'),
                    attribute_name: "core_waybill_level",
                    placeholder: this.$t('models.attributes.materials.core_waybill_level'),
                    type: "number",
                },
                {
                    // human_name: "識別名稱",
                    human_name:  this.$t('models.attributes.materials.class_name'),
                    attribute_name: "class_name",
                    placeholder: this.$t('models.attributes.materials.class_name'),
                    type: "text",
                },
                {
                    // human_name: "標籤種類",
                    human_name:  this.$t('models.attributes.materials.label_type'),
                    attribute_name: "label_type",
                    placeholder: this.$t('models.attributes.materials.label_type'),
                    type: "selection",
                    options: [
                        {
                            label_type: "Label::ByExpress",
                            human_name: "Label::ByExpress"
                        }
                    ],
                    option_attribute_name: "label_type",
                    option_human_name: "human_name",
                },
            ],
            authentication_token: localStorage.getItem("authentication_token"),
            index_item_name: this.$t('models.materials'),
            api_response_corresponding_name_of_index_item: "material",
            create_index_item_url: {
                type: "http",
                url: this.$store.state.provider.routes.api_v1_provider_materials_create,
                params: [],

            },
            after_create_url: {
                type: "vue",
                url: "edit_material",
                params: [
                    {
                        key_name: "material_identity",
                        attribute_name: "identity",
                        source: "index_item",
                    }
                ]
            }
        }
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    computed: {
    },
    methods: {
    },
    components: {
        CRUDTemplate,
    }
}
</script>

<style scoped>
</style>
